module.exports = __webpack_public_path__ + "static/media/gift.6d1ee538.png";